import React from 'react';

import CommonContainer from "../../containers/Common";

interface Props {
  meganetLensMasterId: number,
}

export default ((props) => {

  const commonContainer = CommonContainer.useContainer();
  const lens = commonContainer.getLens(props.meganetLensMasterId);

  return (
    <>{lens ? lens.lensName : ''}</>
  );
}) as React.FC<Props>;
